import { 
    TOKEN_SUCCESS,
    AUTH_SUCCESS,
    AUTH_FAIL,
    SESSION_CLOSE,
    AUTH_ACTIVE,
    SUBS_ACTIVE
} from './AuthTypes';

export default (state, action) => {
    switch(action.type) {
        case TOKEN_SUCCESS:
            return {
                ...state,
                token: action.payload
            }
        case AUTH_SUCCESS:
            return {
                ...state,
                authenticated: true,
                claims: action.payload
            }
        case AUTH_FAIL:
            return {
                ...state,
                authenticated: false,
                error: action.payload
            }
        case SESSION_CLOSE:
            return{
                ...state,
                authenticated: false,
                token: null,
                claims: null,
                subcribed: null
            }
        case AUTH_ACTIVE:
            return {
                ...state,
                subcribed: true,
                authenticated: true,
                claims: action.payload
            }
        case SUBS_ACTIVE:
            return {
                ...state,
                subcribed: true
            }
        default:
            return state;
    }
}